import { withApnBesideYearBuilt } from '../../../shared';
import type { TenantLocaleOverrides } from '../base';

export const MDOverrides: TenantLocaleOverrides = {
  locale: 'MD',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            withApnBesideYearBuilt(layout).concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            assessorParcelNumber: {
              name: 'property.assessorParcelNumber',
              entity: 'property',
              type: 'text',
              label: 'APN Number',
              placeholderText: '',
            },
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText: 'Copy legal description from tax records',
            },
          },
        },
      },
    },
  },
};
